import React from "react";

import { HStack } from "@chakra-ui/react";

import {
  FileGalleryFragment,
  MessageFragment,
  MessageThreadFragment,
} from "gql/graphql";
import FileGalleryDownloadButton from "./file-gallery-download-button";
import FileGalleryViewMessageButton from "./file-gallery-view-message-button";
import FileGalleryDeleteFileButton from "./file-gallery-delete-file-button";
import FileGalleryAddReactionButton from "./file-gallery-add-reaction-button";
import FileGalleryEditImageButton from "./file-gallery-edit-image-button";
import FileGalleryReplyButton from "./file-gallery-reply-button";
import FileGalleryForwardButton from "./file-gallery-forward-button";

interface IProps {
  messageThread?: MessageThreadFragment;
  message?: MessageFragment;
  file: FileGalleryFragment;
  allowDelete: boolean;
}

const SliderFileButtons = ({
  messageThread,
  message,
  file,
  allowDelete,
}: IProps) => (
  <HStack py={2} spacing={2} justifySelf="center">
    {message && messageThread && (
      <FileGalleryAddReactionButton
        file={file}
        messageThread={messageThread}
        message={message}
      />
    )}
    {message && messageThread && (
      <FileGalleryReplyButton
        messageThread={messageThread}
        file={file}
        message={message}
      />
    )}
    {message && messageThread && (
      <FileGalleryForwardButton
        messageThread={messageThread}
        message={message}
      />
    )}
    {messageThread && (
      <FileGalleryEditImageButton
        messageThread={messageThread}
        draftId={messageThread.id}
        file={file}
      />
    )}
    <FileGalleryViewMessageButton file={file} />
    <FileGalleryDownloadButton file={file} />
    <FileGalleryDeleteFileButton file={file} allowDelete={allowDelete} />
  </HStack>
);

export default SliderFileButtons;
